var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStatusMobileLight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 44,
    viewBox: "0 0 27 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0438 30.6842V0L0.0546875 22.4503L13.0438 30.6842Z",
    fill: "#7E7E7E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0439 0L26.0331 22.4503L13.0439 30.6842V0Z",
    fill: "#2E2E2E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.0546875 25.1092L13.0654 33.3645V44",
    fill: "#7E7E7E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0331 25.1092L13.0439 33.3645V44",
    fill: "#2E2E2E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M13.0439 15.0955L0.0332031 22.4503L13.0439 30.6842V15.0955Z",
    fill: "#323232"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M13.0439 15.0955L26.0331 22.4503L13.0439 30.6842V15.0955Z",
    fill: "#121212"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0438 30.6842V0L0.0546875 22.4503L13.0438 30.6842Z",
    fill: "#ECEEF3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0439 0L26.0331 22.4503L13.0439 30.6842V0Z",
    fill: "#ECEEF3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M13.0439 0L26.0331 22.4503L13.0439 30.6842V0Z",
    fill: "#313131"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M0.0546875 25.1092L13.0654 33.3645V44",
    fill: "#ECEEF3"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0331 25.1092L13.0439 33.3645V44",
    fill: "#ECEEF3"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M26.0331 25.1092L13.0439 33.3645V44",
    fill: "#313131"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M13.0439 15.0955L0.0332031 22.4503L13.0439 30.6842V15.0955Z",
    fill: "#313131"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M13.0439 15.0955L26.0331 22.4503L13.0439 30.6842V15.0955Z",
    fill: "#313131"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusMobileLight);
export default __webpack_public_path__ + "static/media/status_mobile_light.c51dfff2.svg";
export { ForwardRef as ReactComponent };